import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

export const getClientprofile = createAsyncThunk(
    "vehicle/getClientprofile",
    async (props) => {
        const data = props
        const client = data.client;
        const country = data.country

        const profileName = client === "jdpa" ? "jdpa" : `${client}-${country || "us"}`;
        const fullUrl = `/config/call`;
        const response = await axios.get(fullUrl, {
            headers: {
                "x-profile-name": profileName,
            }
        });
        return response.data
    }
)

function buildProfileName(client, country) {
    if (!client || client === "jdpa") return "jdpa";
    const resolvedCountry = country || "us";
    return `${client}-${resolvedCountry}`;
}

export const fetchVehicleData = createAsyncThunk(
    "vehicle/fetchAllVehicles",
    async (data, { getState }) => {
        const state = getState();
        const config = {
            headers: {
                "Accept-Language": data.locale ? data.locale : data.LOCALE,
                "x-profile-name": buildProfileName(state.vehicle.client, state.vehicle.country),
            },
        };

        const url = await axios.get(
            `/api/models/primary`,
            config
        );
        const response = { ...url }
        sessionStorage.setItem("primary", JSON.stringify(response.data.vehicles));
        return response.data;
    }
);

export const fetchTrimData = createAsyncThunk(
    "vehicle/fetchTrimData",
    async (vehicleCode, { getState }) => {
        const state = getState();
        const config = {
            headers: {
                "Accept-Language": state.vehicle.activeLocale || state.vehicle.defaultLanguage,
                "x-profile-name": buildProfileName(state.vehicle.client, state.vehicle.country),
            },
        };

        const url = await axios.get(
            `/api/models/${vehicleCode}/vehicles`,
            config
        );
        const response = { ...url };
        return response.data;
    }
);

export const secondaryYears = createAsyncThunk(
    "vehicle/secondaryYears",
    async (_,{ getState })=> {
        const state = getState();
        const config = {
            headers: {
                "Accept-Language": state.vehicle.activeLocale || state.vehicle.defaultLanguage,
                "x-profile-name": buildProfileName(state.vehicle.client, state.vehicle.country),
            },
        };

        const url = await axios.get(
            `/api/models/secondary/years`, config);
        const response = { ...url };
        return response.data;
    }
);

let previousTrimCode = null;

export const PostcompareData = createAsyncThunk(
    "vehicle/PostcompareData",
    async (TrimCode, { getState }) => {

        const state = getState();
        const config = {
            headers: {
                "Accept-Language": state.vehicle.activeLocale || state.vehicle.defaultLanguage,
                "x-profile-name": buildProfileName(state.vehicle.client, state.vehicle.country),
            },
        };

        let vehicleSData = [];
        let exterior = null;

        if (TrimCode.hasOwnProperty('exterior') && TrimCode.hasOwnProperty('code')) {
            exterior = TrimCode.exterior;
            vehicleSData = TrimCode.code;
        } else {
            for (let i = 0; i < TrimCode.length; i++) {
                vehicleSData.push({code: TrimCode[i].code});
            }
        }

        const data = {
            primaryColor: {
                exterior: exterior ? exterior : null,
            },
            include: {
                vehicleDetails: true,
                skipCustomSort: state.vehicle?.isVehicleSwapped ? true : hasSecondariesChanged(TrimCode,state)
            },
            vehicles: vehicleSData,
        };

        if ( exterior === null || exterior.toString() === "NO_COLOR" ){
            data.primaryColor = {}
        }

        try {
            const url = await axios.post( `/api/text`, data, config);
            const response = {...url};
            const responseData = response.data;

            sessionStorage.setItem(
                "compareData",
                JSON.stringify({
                    trimCodes: TrimCode,
                    data: responseData,
                    exterior: exterior
                })
            );

            if (responseData.vehicles && responseData.vehicles.length > 0 && TrimCode.exterior === null ) {
                responseData.vehicles.forEach(async vehicle => {
                    if (vehicle.code === TrimCode.code[0].code) {
                        const newData = {
                            ...data,
                            primaryColor: {
                                exterior: vehicle.currentColor
                            },
                            vehicles: vehicleSData
                        };
                        const TrimCodes = {
                            ...TrimCode,
                            exterior: vehicle.currentColor
                        };
                        sessionStorage.setItem("exteriorColor", vehicle.currentColor );

                        try {
                            const newUrl = await axios.post(`/api/text`, newData, config);
                            const newResponse = { ...newUrl };
                            const newResponseData = newResponse.data;
                            sessionStorage.removeItem("compareData")

                            sessionStorage.setItem(
                                "compareData",
                                JSON.stringify({
                                    trimCodes: TrimCodes,
                                    data: newResponseData,
                                    exterior: vehicle.currentColor
                                })
                            );


                        } catch (error) {
                            console.error(error)
                        }
                    }
                });
            }

            return responseData;
        } catch (error) {
            if (error) {
                const statusCode = error.response.data.code;
                return { statusCode };
            }
        }
    }
);

export const postCompareImages = createAsyncThunk(
    "vehicle/postCompareImages",
    async (TrimCode, { getState }) => {
        const state = getState();
        const config = {
            headers: {
                "Accept-Language": state.vehicle.activeLocale || state.vehicle.defaultLanguage,
                "x-profile-name": buildProfileName(state.vehicle.client, state.vehicle.country),
            },
        };

        let vehicleSData = [];
        let exterior;
        if (TrimCode.hasOwnProperty("exterior") && TrimCode.hasOwnProperty("code")) {
            exterior = TrimCode.exterior;
            vehicleSData = TrimCode.code
        } else {
            for (let i = 0; i < TrimCode.length; i++) {
                vehicleSData.push({ code: TrimCode[i].code });
            }
        }

        const data = {
            primaryColor: {
                exterior,
            },
            include: {
                vehicleDetails: true,
            },
            vehicles: vehicleSData,
        };
        const compareImages = sessionStorage.getItem("compareImages");
        if (
            JSON.stringify(TrimCode) !== JSON.stringify(previousTrimCode) ||
            !compareImages
        ) {
            const url = await axios.post( `/api/image`, data, config);
            const response = { ...url };
            sessionStorage.setItem(
                "compareImages",
                JSON.stringify(response.data));
            sessionStorage.removeItem('isArrayFilled');
            previousTrimCode = TrimCode;
        }
        return JSON.parse(sessionStorage.getItem("compareImages"));
    }
);

export const exportFeatureList = createAsyncThunk(
    "vehicle/exportFeatureList",
    async (TrimCode, { getState }) => {
        const state = getState();
        const config = {
            headers: {
                "Accept-Language": state.vehicle.activeLocale || state.vehicle.defaultLanguage,
                "x-profile-name": buildProfileName(state.vehicle.client, state.vehicle.country),
                Accept: "application/pdf",
            },
            responseType: "blob"
        };
        const {pathname} = window.location;
        let vehicleSData;
        let exterior;
        if (TrimCode.hasOwnProperty("exterior") && TrimCode.hasOwnProperty("code")) {
            exterior = TrimCode?.exterior;
            vehicleSData = TrimCode.code
        } else {
            for (let i = 0; i < TrimCode.length; i++) {
                vehicleSData.push({ code: TrimCode[i].code });
            }
        }

        const data = {
            primaryColor: {
                exterior: exterior ? exterior : null,
            },
            include: {
                vehicleDetails: true,
                skipCustomSort: state.vehicle?.isVehicleSwapped ? true : hasSecondariesChanged(TrimCode,state)
            },
            vehicles: vehicleSData,
        };

        const response = await axios.post(
            `/api` + `${pathname.includes('photos') ? "/image.pdf" :  "/text.pdf"}`,
            data,
            config
        );
        const vehicleName = state.vehicle.primaryVehicleYear + " " + state.vehicle.primaryVehicleMake + " " + state.vehicle.primaryVehicleModel +" - Compare";
        const fileName = `${vehicleName}.pdf`;

        function createDownloadLink(blob, fileName) {
            const downloadLink = document.createElement("a");
            downloadLink.href = window.URL.createObjectURL(blob);
            downloadLink.download = fileName;
            if (window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(blob, fileName);
            } else {
                document.body.appendChild(downloadLink);
                downloadLink.click();
                document.body.removeChild(downloadLink);
            }
        }

        createDownloadLink(response.data, fileName);
    }
);


export const secondarySearch = createAsyncThunk(
    "vehicle/secondarySearch",
    async (year, {getState}) => {
        const state = getState()
        const config = {
            headers: {
                "Accept-Language": state.vehicle.activeLocale || state.vehicle.defaultLanguage,
                "x-profile-name": buildProfileName(state.vehicle.client, state.vehicle.country),
            },
        };
        const data = {
            search: {
                year: year,
            },
        };

        const url = await axios.post(
            `/api/models/secondary/search`,
            data,
            config
        );
        const response = { ...url };
        return response.data;
    }
);

export const searchMake = createAsyncThunk(
    "vehicle/searchMake",
    async (search, {getState}) => {
        const state = getState()
        const config = {
            headers: {
                "Accept-Language": state.vehicle.activeLocale || state.vehicle.defaultLanguage,
                "x-profile-name": buildProfileName(state.vehicle.client, state.vehicle.country),
            },
        };
        const data = {
            search: {
                year: search[0],
                make: search[1],
            },
        };
        const url = await axios.post(
            `/api/models/secondary/search`,
            data,
            config
        );
        const response = { ...url };
        return response.data;
    }
);

export const getAvailableTrims = createAsyncThunk(
    "vehicle/getAvailableTrims",
    async ({ vehicleCode, iccCode }, {getState}) => {
        const state = getState();
        const config = {
            headers: {
                "Accept-Language": state.vehicle.activeLocale || state.vehicle.defaultLanguage,
                "x-profile-name": buildProfileName(state.vehicle.client, state.vehicle.country),
            },
        }

        const url = await axios.get(
            `/api/models/${vehicleCode}/vehicles/${iccCode}`,
            config
        );
        const response = { ...url };
        return response.data;
    });


export const vehicleSlice = createSlice({
    name: "vehicle",
    initialState: {
        years: [],
        year: null,
        vehicles: [],
        code: null,
        filters: {
            segments: [],
        },
        filteredPriceRange: {
            segments: [],
        },
        featureDefinitions: [],
        trimVehicle: [],
        trimImage: [],
        featurePosition: [],
        filterData: [],
        featuresKey: [],
        selectedSegment: [],
        priceRange: [],
        filteredPrice: [],
        min: "",
        max: "",
        minimumPriceRange: "",
        maximumPriceRange: "",
        filterSegment: [],
        selectedSegmentArray: [],
        defaultAccSegment: [],
        filterPriceSegment: [],
        priceRangeSegments: [],
        defaultVehicleSegment: [],
        trimCode: [],
        modelYear: [],
        modelName: [],
        modelTrim: [],
        trimVariation: [],
        modelImage: [],
        trimData: [],
        features: [],
        updatedPrice:[0,0],
        featureVehicles: [],
        isFeatureChecked: false,
        isCheckedAdvantages: true,
        secondaryVehicles: null,
        vehicleMake: null,
        compareImages: null,
        profileView: "FRONT_3QTR_LEFT",
        imageTypeView: "EXTERIOR",
        filteredGallaryView: null,
        printState: false,
        activeSecondaryVehicleId: null,
        featureSearch: null,
        featureLabel: [],
        defaultLabel: [],
        featureRow: [],
        isExpandedCategory: null,
        vehicleCodes: [],
        driveTypeDefault: {
            VEHICLE_TYPE: [],
            VEHICLE_TYPE_NAME: null,
        },
        secondaryMake: [],
        vehicleIndex: [],
        makeData: [],
        activeVehicleIndex: 0,
        activeFeatureCategory: null,
        secondaryYear: [],
        clientCconfig: {},
        akanaAppId: null,
        profileKey: null,
        supportedLanguages: [],
        headerLoadType: null,
        defaultLanguage: null,
        activeLocale: null,
        primaryVehicle: null,
        defaultMinPriceRange: null,
        defaultMaxPriceRange: null,
        minimumPrice: null,
        maximumPrice: null,
        ctaButtons: null,
        ctaRedirect: null,
        clientTheme: null,
        googleTagManagerIds: null,
        oneTrustLink: null,
        oneTrustToken: null,
        client: null,
        country: null,
        overview: false,
        status: 'idle',
        error: null,
        errorCode: null,
        data: null,
        exteriorColor: sessionStorage.getItem("exteriorColor") || null,
        buttonHandlerTxt: null,
        isOpen: null,
        removedVehicleCodes: [],
        removedVehicleIndex: [],
        statusCode: null,
        imageAngle: "EXTERIOR",
        currentTarget : null,
        iconColorCode: null,
        activeToolTipVehicle: null,
        selectedVehicleCode: null,
        selectedVehicleMSRP: null,
        primaryVehicleDescription: null,
        secondaryOneVehicleDescription: null,
        secondaryTwoVehicleDescription: null,
        secondaryThreeVehicleDescription: null,
        color: null,
        primaryVehicleMSRP: null,
        secondaryOneVehicleMSRP: null,
        secondaryTwoVehicleMSRP: null,
        secondaryThreeVehicleMSRP: null,
        primaryVehicleYear: null,
        primaryVehicleTrim: null,
        primaryVehicleMake: null,
        primaryVehicleModel: null,
        lockedVehicles: null,
        lockedCompetitorVehicles: null,
        primaryChanged: false,
        isDifferenceOnly: false,
        expandedCategory: null,
        trimType: null,
        isCompareTrimSelected:false,
        loading: null,
        vehicleCode: 0,
        secondaryVehicleIndex: 0,
        secondaryCarouselIndex: 0,
        carouselIndex: 0,
        isPrimaryVehicleCarousel: false,
        hasModifiedEquipment: false,
        isVehicleSwapped: false,
        angleChanged: false,
        swapTriggered: false
    },
    reducers: {
        selectYear: (state, action) => {
            state.year = action.payload;
            state.defaultAccSegment = []
            state.filters.segments = [...state.defaultVehicleSegment];
            state.selectedSegment = [];
            state.priceRange = [];
            state.filteredPrice = [];
            state.filterSegment = [];
            state.defaultAccSegment = [];
            state.filterPriceSegment = [];
            state.priceRangeSegments = [];
            state.compareImages = [];
            state.filterSegment = [];
            state.filteredPrice = []
        },

        swapCompareImages: (state, action) => {
            const { firstIndex = 1, secondIndex, swapTriggered } = action.payload || {};
            state.swapTriggered = swapTriggered;
            if (Array.isArray(state.compareImages) &&
                secondIndex > 0 &&
                secondIndex < state.compareImages.length) {

                const temp = state.compareImages[firstIndex];
                state.compareImages[firstIndex] = state.compareImages[secondIndex];
                state.compareImages[secondIndex] = temp;
            }
        },

        getVehicleIndex: (state, action) => {
            state.vehicleIndex = action.payload;
        },
        getTrimCodes: (state, action) => {
            state.vehicleCodes = action.payload;
        },
        clearCompareData:(state, action) => {
            state.isVehicleSwapped = false;
            state.features = [];
            state.featureLabel = [];
            state.featureRow = [];
            state.defaultLabel = [];
            state.featureVehicles = [];
            state.vehicleCodes = [];
            state.removedVehicleCodes = [];
            state.removedVehicleIndex = [];
            state.vehicleCodes = [];
        },

        clearPhotoStates: (state,action) => {
            state.compareImages = [];
        },

        resetFilterButtons: (state, action) =>{
            state.imageTypeView = action.payload;
        },

        sendErrorMessage:(state, action)=> {
            state.error = action.payload.error;
            state.errorCode = action.payload.errorCode;

        },
        getExteriorColorCode: (state, action) => {
            state.exteriorColor = action.payload;
            sessionStorage.setItem("exteriorColor", action.payload);
        },
        getSelectedModel: (state, action) => {
            state.code = action.payload;
        },
        getMakeData: (state, action) => {
            state.makeData = action.payload;
        },
        getSelectedSegment: (state, action) => {
            state.selectedSegment = action.payload && [...action.payload];
        },
        getActiveFeatureCategory: (state, action) => {
            state.activeFeatureCategory = action.payload
        },
        getSegmentsByFilter: (state, action) => {
            if (action.payload?.segmentClicked){
                const segmentIndex = state.selectedSegmentArray.indexOf(action.payload.segmentClicked);
                if (segmentIndex === -1) {
                    state.selectedSegmentArray = [...state.selectedSegmentArray, action.payload.segmentClicked];
                } else {
                    state.selectedSegmentArray = state.selectedSegmentArray.filter(
                        segment => segment !== action.payload.segmentClicked
                    );
                }
            } else if (action.payload?.clearSegments) {
                state.selectedSegmentArray = [];
            } else{
                if (action.payload.isFilter) {
                    const segmentArray = state.filterSegment.filter(
                        (item) => item !== action.payload.id
                    );
                    state.filterSegment = [...segmentArray];
                } else {
                    state.filterSegment = action.payload;
                }
            }
            if(action.payload.clearData){
                state.filterSegment = [];
                state.selectedSegment = [];
            }
        },
        vehicleHasSwapped: (state, action) => {
            state.isVehicleSwapped = action.payload;
        },

        setVehiclesPrinceRange:(state, action) => {
            state.defaultMinPriceRange = action.payload.minimumPrice;
            state.defaultMaxPriceRange = action.payload.maximumPrice;
        },

        getCarouselIndexKey: (state,action) =>{
            state.activeVehicleIndex = action.payload;
        },

        getFeatuerSearch: (state, action) => {
            state.featureSearch = action.payload;
            sessionStorage.setItem('featureSearch', state.featureSearch);
        },

        isFetureNavigate: (state,action) => {

            if (action.payload.Feature){

                state.currentTarget = "Features";
            }else if (action.payload.Photo){

                state.currentTarget = "Photos";
            }
        },

        getDefaultYear: (state, action) => {
            state.year = action.payload;
        },

        setButtonHandlerText: (state, action) => {
            state.buttonHandlerTxt = action.payload;
        },

        hasOverview:(state, action) => {
            state.overview = action?.payload;
        },

        getSelectedPriceRange: (state, action) => {
            state.priceRange = [...action.payload];

            state.filterPriceSegment = [];
            state.filters.segments = [...state.defaultVehicleSegment];
        },

        setFilteredPrinceRange: (state, action) => {
            if (action.payload?.price) {
                state.filteredPrice = [...action.payload.price];
            } else if (action.payload?.initialPriceRange) {
                state.submittedPrice = [...action.payload.initialPriceRange];
            } else if (action.payload?.resetFilters) {
                state.filterSegment = [];
            }
            if (action.payload?.selectedSegment) {
                state.filterSegment = [];
            }
            state.filteredPriceRange.segments = [];
        },

        handlePriceRangeSlider: (state, action) => {
            if (action.payload?.min !== undefined) {
                state.min = action.payload.min;
            }
            if (action.payload?.max !== undefined) {
                state.max = action.payload.max;
            }
            if (action.payload?.minimumPrice !== undefined) {
                state.minimumPriceRange = action.payload.minimumPrice;
            }
            if (action.payload?.maximumPrice !== undefined) {
                state.maximumPriceRange = action.payload.maximumPrice;
            }
        },

        storeLockedVehicles:(state, action) => {
            return {
                ...state,
                lockedVehicles: action.payload,
            };
        },

        getDefaultAccordionSegment: (state, action) => {
            state.defaultAccSegment = [...state.defaultAccSegment, action.payload];
        },

        getFiltePriceSegment: (state, action) => {
            if (!state.filterPriceSegment?.includes(action.payload)) {
                state.filterPriceSegment = [
                    ...state.filterPriceSegment,
                    action.payload,
                ];

                state.filters.segments = [...state.filterPriceSegment];
            }
        },

        getFilteredSegments: (state, action) => {
            if (!state.priceRangeSegments?.includes(action.payload)) {
                state.priceRangeSegments = [
                    ...state.priceRangeSegments,
                    action.payload,
                ];

                state.filteredPriceRange.segments = [...state.priceRangeSegments];
            }
        },

        setUpdatedPriceRange: (state, action) => {
            state.updatedPrice = action.payload;
        },

        getTrimCode: (state, action) => {
            state.trimCode = action.payload;
        },

        getExpandedCategory: (state, action) => {
            state.isExpandedCategory = action.payload;
        },

        setProfileView: (state, action) => {
            state.profileView = action.payload;
        },

        isExpandedArr: (state, action) => {
            state.isOpen = action.payload;
        },

        setVehicleInfo:(state, action) => {
            if (action.payload.isDesktop) {
                state.activeToolTipVehicle = action.payload.vehicleIndex
            }
            if (!(action.payload.isDesktop)){
                state.activeToolTipVehicle = action.payload.vehicleIndex
            }
        },

        setRemovedVehicle: (state, action) => {
            state.removedVehicleIndex = state.removedVehicleIndex.filter(index => index !== undefined)
            if (action.payload?.code !== undefined) {
                state.removedVehicleCodes = [...state.removedVehicleCodes, action.payload.code];
            }
            if (action.payload?.id !== undefined && !state.removedVehicleIndex.includes(action.payload?.id)) {
                state.removedVehicleIndex = [...state.removedVehicleIndex, action.payload?.id];
            }
            if (action.payload.remove ){
                state.removedVehicleCodes = [];
            }
            if (action.payload.primaryChanged){
                state.primaryChanged = true;
            }else {
                state.primaryChanged = false;
            }
        },

        setImageType: (state,action) => {
            state.imageAngle = action.payload;
        },

        setErrorStatusCode: (state,action)=>{
            state.error = action.payload.error;
            state.statusCode = action.payload;
        },

        setImageTypeView: (state, action) => {
            state.imageTypeView = action.payload;
        },

        setCheckedFeature: (state, action) => {
            state.isFeatureChecked = action.payload;
            sessionStorage.setItem('isFeatureChecked', state.isFeatureChecked);

            if (action.payload) {
                state.isFeatureChecked = true
                sessionStorage.setItem('isFeatureChecked', 'true');
            } else {
                state.isFeatureChecked = false;
                sessionStorage.setItem('isFeatureChecked', 'false');
            }
        },

        setAdvantagesCheck: (state, action) => {
            state.isCheckedAdvantages = action.payload;
            sessionStorage.setItem('isCheckedAdvantages', action.payload);

            if (action.payload){
                sessionStorage.setItem('isCheckedAdvantages', action.payload);
            }
        },

        setClientCSS: (state, action) => {
            state.clientTheme = action.payload;
        },

        setColorIcon:(state, action) => {
            state.iconColorCode = action.payload;
        },

        setColorName:(state, action) => {
            state.color = action.payload;
        },

        setActiveLanguage: (state,action) => {
            state.activeLocale = action.payload
        },
        setPrimaryVehicle: (state,action) => {
            state.primaryVehicle = action.payload
        },

        minimumPriceByFilter:(state, action) => {
            if (action.payload.minimumPrice) {
                state.minimumPrice = action.payload.minimumPrice;
            }
            if (action.payload.maximumPrice) {
                state.maximumPrice = action.payload.maximumPrice;
            }
        },

        setVehicleCode:(state, action) => {
            state.vehicleCode= action.payload;
        },

        setCarouselVehicleCode:(state, action) => {
            state.secondaryCarouselIndex= action.payload;
        },

        primaryVehicleCarousel:(state, action) => {
            state.isPrimaryVehicleCarousel= action.payload;
        },

        setIsAngleChanged:(state, action) => {
            state.angleChanged = action.payload;
        },

        setVehicleIndex:(state, action) => {
            state.secondaryVehicleIndex = action.payload;
        },

        setCarouselIndex:(state, action) => {
            state.carouselIndex = action.payload;
        },

        setDifferenceOnly:(state,action) => {
            state.isDifferenceOnly = action.payload;
            sessionStorage.setItem('isDifferenceOnly', action.payload);
        },

        selectedVehicleType: (state,action) =>{
            state.trimType = action.payload;
        },

        updateVehicleOrder: (state, action) => {
            state.featureVehicles = action.payload;
        },

        updatePhotoOrder: (state, action) => {
            state.compareImages = action.payload;
        },

        setTrimVehiclesData: (state, action) => {
            state.trimVehicle = action.payload;
        },

        setCategories: (state, action) => {
            const {panel, newExpanded, removeAll, isAllExpanded} = action.payload;

            if (state.expandedCategory === null || removeAll || isAllExpanded) {
                state.expandedCategory = [];
            }

            state.expandedCategory = state.expandedCategory.filter((item) => item !== undefined);
            const index = state.expandedCategory.findIndex((item) => item.panel === (panel === "all" ? "all" : panel));

            if (index !== -1) {
                state.expandedCategory[index].newExpanded = newExpanded;
            } else {
                state.expandedCategory.push({ panel: panel === "all" ? "all" : panel, newExpanded });
            }

            state.expandedCategory = state.expandedCategory.reduce((unique, item) => {
                const index = unique.findIndex((u) => u.panel === item.panel);
                if (index === -1) {
                    unique.push(item);
                } else {
                    unique[index].newExpanded = item.newExpanded;
                }
                return unique;
            }, []);
        },

        setCompareGroupData: (state, action) => {
            state.primaryVehicleDescription = action.payload?.primaryVehicleDescription;
            state.secondaryOneVehicleDescription = action.payload?.secondaryOneVehicleDescription;
            state.secondaryTwoVehicleDescription = action.payload?.secondaryTwoVehicleDescription;
            state.secondaryThreeVehicleDescription = action.payload?.secondaryThreeVehicleDescription;
            state.primaryVehicleMSRP = action.payload?.primaryVehicleMSRP;
            state.secondaryOneVehicleMSRP = action.payload?.secondaryOneVehicleMSRP;
            state.secondaryTwoVehicleMSRP = action.payload?.secondaryTwoVehicleMSRP;
            state.secondaryThreeVehicleMSRP = action.payload?.secondaryThreeVehicleMSRP;
            state.primaryVehicleYear = action.payload?.primaryVehicleYear;
            state.primaryVehicleTrim = action.payload?.primaryVehicleTrim;
            state.primaryVehicleMake = action.payload?.primaryVehicleMake;
            state.primaryVehicleModel = action.payload?.primaryVehicleModel;
            state.errorCode = action.payload?.errorCode;
        }
    },

    extraReducers: (builder) => {
        builder
            .addCase(fetchVehicleData.fulfilled, (state, action) => {
                state.filters = action.payload.filters;
                state.filteredPriceRange = action.payload.filters;
                state.vehicles = action.payload.vehicles;
                state.defaultVehicleSegment = action.payload.filters && [...action.payload.filters.segments];
            })
            .addCase(fetchVehicleData.rejected, (state, action) => {
                state.error = 'You have encountered an error. Please try again.';
            })
            .addCase(secondaryYears.fulfilled, (state,action) => {
                state.secondaryYear = action.payload.years
            })
            .addCase(secondaryYears.rejected, (state, action) => {
                state.error = 'You have encountered an error. Please try again.';
            })
            .addCase(PostcompareData.pending, (state, action) => {
                state.loading = true;
            })
            .addCase(PostcompareData.fulfilled, (state, action) => {
                const competitorsRemoved = sessionStorage.getItem("competitorsRemoved") === "true";
                if (action.payload.features && action.payload.vehicles) {
                    let features = action.payload.features;
                    let featureVehicles = action.payload.vehicles;

                    if (competitorsRemoved) {
                        featureVehicles = [featureVehicles[0]];
                        features = Object.fromEntries(
                            Object.entries(features).map(([key, feature]) => {
                                const updatedFeatureRows = feature.featureRows.map(row => ({
                                    ...row,
                                    comparisons: row.comparisons.length > 0 ? [row.comparisons[0]] : []
                                }));
                                return [key, { ...feature, featureRows: updatedFeatureRows }];
                            })
                        );
                    }

                    state.features = features;
                    state.loading = false;
                    state.errorCode = null;
                    state.featureLabel = [];
                    state.featureRow = [];

                    Object.keys(features).forEach((featureKey) => {
                        state.featureLabel = state.featureLabel.concat(features[featureKey]);
                        state.featureRow = [
                            ...state.featureRow,
                            features[featureKey].featureRows,
                        ];
                    });

                    state.defaultLabel = state.featureLabel;
                    state.featureVehicles = featureVehicles;
                    state.modelTrim = featureVehicles[0].trim;
                    state.trimVariation = featureVehicles[0].variation;
                    state.vehicleCodes = state.featureVehicles.map((vehicle) => vehicle.code);

                    if (!state.vehicleCodes.includes(action.payload.code)) {
                        state.vehicleCodes.push(action.payload.code);
                        state.vehicleCodes = state.vehicleCodes.filter((code) => code !== undefined);
                    }
                } else if (action.payload.statusCode) {
                    state.loading = false;
                    state.error = action.payload.statusCode;
                }
            })
            .addCase(PostcompareData.rejected, (state, action) => {
                state.statusCode = action.payload && action.payload.statusCode;
                state.loading = false;
                state.error = 'You have encountered an error. Please try again.'
            })
            .addCase(secondarySearch.fulfilled, (state, action) => {
                state.secondaryVehicles = action.payload;
            })
            .addCase(secondarySearch.rejected, (state, action) => {
                state.error = 'You have encountered an error. Please try again.';
            })
            .addCase(searchMake.fulfilled, (state, action) => {
                state.vehicleMake = action.payload;
            })
            .addCase(searchMake.rejected, (state, action) => {
                state.error = 'You have encountered an error. Please try again.';
            })
            .addCase(postCompareImages.pending, (state, action) => {
                state.loading = true;
            })
            .addCase(postCompareImages.fulfilled, (state, action) => {
                const competitorsRemoved = sessionStorage.getItem("competitorsRemoved");
                if (competitorsRemoved === "true") {
                    state.compareImages = action.payload.vehicles ? [action.payload.vehicles[0]] : [];
                    state.vehicleCodes = state.compareImages.map((vehicle) => vehicle?.code);
                } else {
                    state.compareImages = action.payload.vehicles;
                    state.vehicleCodes = state.compareImages.map((vehicle) => vehicle?.code);
                    if (!state.vehicleCodes.includes(action.payload.code)) {
                        state.vehicleCodes.push(action.payload.code);
                        state.vehicleCodes = state.vehicleCodes.filter((code) => code !== undefined);
                    }
                }
                state.loading = false;
                state.error = null;
                state.errorCode = null;
            })
            .addCase(postCompareImages.rejected, (state, action) => {
                state.error = 'You have encountered an error. Please try again.';
                state.loading = false;
            })
            .addCase(getClientprofile.fulfilled, (state,action) => {
                state.clientCconfig = action.payload;
                state.akanaAppId = action.payload.akanaAppId;
                state.profileKey = action.payload.profileKey;
                state.customerKey = action.payload.customerKey;
                state.supportedLanguages = action.payload.supportedLanguages;
                state.headerLoadType = action.payload.headerLoadType;
                state.defaultLanguage = action.payload.defaultLanguage;
                state.clientTheme = action.payload.theme;
                state.googleTagManagerIds = action.payload.googleTagManagerIds;
                state.oneTrustLink = action.payload.oneTrustLink;
                state.oneTrustToken = action.payload.oneTrustToken;
                state.ctaButtons = action.payload.ctaButtons;
                state.country = action.payload.country;
                state.client = action.payload.client;
                state.allAdvantage = action.payload.allAdvantage;
                state.ctaRedirect = action.payload.redirectButtons && action.payload.redirectButtons[0] ;
            })
            .addCase(getClientprofile.rejected, (state, action) => {
                state.error = 'You have encountered an error. Please try again.';
            })
            .addCase(exportFeatureList.fulfilled, (state, action) => {})

            .addCase(fetchTrimData.fulfilled, (state, action) => {
                state.featureDefinitions = action.payload.featureDefinitions;
                const featureKeys = Object.keys(action.payload.featureDefinitions);

                let maxFeatureKey = featureKeys[0];
                let allKeysHaveSameLength = true;

                for (let i = 1; i < featureKeys.length; i++) {
                    if (action.payload.featureDefinitions[featureKeys[i]].length > action.payload.featureDefinitions[maxFeatureKey].length) {
                        maxFeatureKey = featureKeys[i];
                        allKeysHaveSameLength = false;
                    } else if (action.payload.featureDefinitions[featureKeys[i]].length < action.payload.featureDefinitions[maxFeatureKey].length) {
                        allKeysHaveSameLength = false;
                    }
                }

                if (allKeysHaveSameLength) {
                    if (featureKeys.length === 1) {
                        maxFeatureKey = featureKeys[0];
                    } else {
                        maxFeatureKey = featureKeys[1];
                    }
                }

                state.driveTypeDefault.VEHICLE_TYPE = action.payload.featureDefinitions[maxFeatureKey];
                state.driveTypeDefault.VEHICLE_TYPE_NAME = maxFeatureKey;
                state.trimVehicle = action.payload.vehicles;
                // Use the getUniqueSortedSet function to sort drive types
                const uniqueSortedDriveTypes = getUniqueSortedSet(state.trimVehicle, state.driveTypeDefault.VEHICLE_TYPE_NAME);
                state.driveTypeDefault.VEHICLE_TYPE = uniqueSortedDriveTypes;
            })
            .addCase(fetchTrimData.rejected, (state, action) => {
                state.error = 'You have encountered an error. Please try again.';
                state.trimVehicle = [];
            })
            .addCase(getAvailableTrims.fulfilled, (state, action) => {
                state.trimVehicle = action.payload.vehicles;
            })


    },
});
export const {
    selectYear,
    selectModelCode,
    getSelectedSegment,
    getDefaultYear,
    getSelectedPriceRange,
    getSegmentsByFilter,
    getDefaultAccordionSegment,
    getFiltePriceSegment,
    getTrimCode,
    getTrimData,
    setCheckedFeature,
    setAdvantagesCheck,
    setProfileView,
    setImageTypeView,
    getFeatuerSearch,
    getExpandedCategory,
    getVehicleIndex,
    getMakeData,
    getCarouselIndexKey,
    getActiveFeatureCategory,
    setActiveLanguage,
    setPrimaryVehicle,
    clearCompareData,
    sendErrorMessage,
    getTrimCodes,
    getExteriorColorCode,
    setButtonHandlerText,
    isExpandedArr,
    setRemovedVehicle,
    setErrorStatusCode,
    setImageType,
    clearPhotoStates,
    resetFilterButtons,
    isFetureNavigate,
    setVehicleInfo,
    setClientCSS,
    setColorIcon,
    minimumPriceByFilter,
    setCompareGroupData,
    setColorName,
    setVehiclesPrinceRange,
    storeLockedVehicles,
    setDifferenceOnly,
    setCategories,
    selectedVehicleType,
    setVehicleCode,
    setVehicleIndex,
    setCarouselIndex,
    updateVehicleOrder,
    vehicleHasSwapped,
    setCarouselVehicleCode,
    primaryVehicleCarousel,
    setIsAngleChanged,
    swapCompareImages,
    setFilteredPrinceRange,
    getFilteredSegments,
    handlePriceRangeSlider,
    setUpdatedPriceRange,
    setTrimVehiclesData
} = vehicleSlice.actions;

export default vehicleSlice.reducer;

export const getSelectedYear = (state) => state.vehicle.year;
export const selectedSegment = (state) => state.vehicle.selectedSegment;
export const priceRange = (state) => state.vehicle.priceRange;
export const setUpdatedPrice = (state) => state.vehicle.updatedPrice;
export const defaultAccordionSegment = (state) => state.vehicle.defaultAccSegment;
export const setSecondariesMake = (state) => state.vehicle.secondaryVehicles;
export const getVehiclesByYear = (state) => state.vehicle.vehicles;
export const getTrimModels = (state) => state.vehicle.trimVehicle;
export const getDriveTypes = (state) => state.vehicle.featureDefinitions;
export const getDefaultDriveTpes = (state) => state.vehicle.driveTypeDefault;
export const getSegments = (state) => state.vehicle.filters && state.vehicle.filters.segments;
export const activeFeatureName = (state) => state.vehicle.activeFeatureCategory
export const setTrimModelName = (state) => state.vehicle.modelName;
export const setTrimModelYear = (state) => state.vehicle.modelYear;
export const setTrimModelImage = (state) => state.vehicle.modelImage;
export const searchMakeCodes = (state) => state.vehicle.vehicleMake;
export const getActiveIndex = (state) => state.vehicle.activeVehicleIndex;
export const getFeatures = (state) => state.vehicle.features;
export const getFeatureChecked = (state) => state.vehicle.isFeatureChecked;
export const getAdvantagesCheck = (state) => state.vehicle.isCheckedAdvantages;
export const getProfileView = (state) => state.vehicle.profileView;
export const getImageTypeView = (state) => state.vehicle.imageTypeView;
export const getFeartureSearched = (state) => state.vehicle.featureSearch;
export const setFeatureRow = (state) => state.vehicle.featureRow;
export const setExpandedFeature = (state) => state.vehicle.isExpandedCategory;
export const setCurrentTarget = (state) => state.vehicle.currentTarget;
export const setMakeData = (state) => state.vehicle.makeData;
export const VehicleIndex = (state) => state.vehicle.vehicleIndex;
export const setSupportedLanguages = (state) =>  state.vehicle.supportedLanguages;
export const setHeaderLoadType = (state) => state.vehicle.headerLoadType;
export const setDefaultLanguage = (state) =>  state.vehicle.defaultLanguage;
export const setPrimaryVehicleCode = (state) => state.vehicle.primaryVehicle;
export const setActiveLocale = (state) => state.vehicle.activeLocale;
export const setCTAbuttons = (state) => state.vehicle.ctaButtons;
export const setCTARedirectURL = (state) => state.vehicle.ctaRedirect;
export const setAllAdvantage = (state) => state.vehicle.allAdvantage;
export const setTheme = (state) => state.vehicle.clientTheme;
export const setTagManagerIds = (state) => state.vehicle.googleTagManagerIds;
export const getOneTrustLink = (state) => state.vehicle.oneTrustLink;
export const getOneTrustToken = (state) => state.vehicle.oneTrustToken;
export const exterirorColorCode = (state) => state.vehicle.exteriorColor
export const setErrorMessage = (state) => state.vehicle.error;
export const setErrorCode = (state) => state.vehicle.errorCode;
export const setStatusCode = (state) => state.vehicle.statusCode;
export const buttonHandler = (state) => state.vehicle.buttonHandlerTxt;
export const defaultMinPrice = (state) => state.vehicle.defaultMinPriceRange;
export const defaultMaxPrice = (state) => state.vehicle.defaultMaxPriceRange;
export const isOpen = (state) => state.vehicle.isOpen;
export const setClient = (state) => state.vehicle.client;
export const setCountry = (state) => state.vehicle.country;
export const setModelTrim = (state) =>  state.vehicle.modelTrim;
export const setModelTrimVariation = (state) =>  state.vehicle.trimVariation;
export const setIconColorCode = (state) => state.vehicle.iconColorCode;
export const isLoading = (state) => state.vehicle.loading;
export const getVehicleCode = (state) => state.vehicle.vehicleCode;
export const getCarouselVehicleIndex = (state) => state.vehicle.secondaryCarouselIndex;
export const getPrimaryCarouselVehicleIndex = (state) => state.vehicle.isPrimaryVehicleCarousel;
export const getSecondaryVehicleIndex = (state) => state.vehicle.secondaryVehicleIndex;
export const getCarouselIndex = (state) => state.vehicle.carouselIndex;
export const hasAngleChanged = (state) => state.vehicle.angleChanged;
export const setMin = (state) => state.vehicle.min;
export const setMax = (state) => state.vehicle.max;
export const setMinimumPriceRange = (state) => state.vehicle.minimumPriceRange;
export const setMaximumPriceRange = (state) => state.vehicle.maximumPriceRange;
export const isSwappedTriggered = (state) => state.vehicle.swapTriggered;

export const setRemovedVehicleIndex = (state) => {
    const removedVehicleIndex = state.vehicle.removedVehicleIndex;
    if (removedVehicleIndex === null || removedVehicleIndex === undefined) {
        return null;
    }
    return removedVehicleIndex;
}

export const hideDisclaimer = (state) => {
    if (state.vehicle?.featureRow && state.vehicle?.featureRow[0]) {
        const found = state.vehicle.featureRow[0].some((id) => {
            if (id?.id === "pricing3" && id?.comparisons?.length > 0) {
                return true;
            }
            return false;
        });
        return found;
    }
    return false;
}

export const storeLockedCompetitors = (state) => {
    const filteredLockedVehicles = {};
    const secondaryTrimCodes = secondaryVehiclesTrims(state);

    for (const key in state.vehicle.lockedVehicles) {
        if (state.vehicle.lockedVehicles.hasOwnProperty(key) && state.vehicle.lockedVehicles[key] !== undefined) {
            const lockedVehicleArray = state.vehicle.lockedVehicles[key];

            if (Array.isArray(lockedVehicleArray)) {
                filteredLockedVehicles[key] = filteredLockedVehicles[key] || [];
                lockedVehicleArray.forEach(lockedVehicle => {
                    const vehicleCode = lockedVehicle.vehicle;
                    const originalIndex = lockedVehicle?.vehicleIndex;
                    let newIndex = secondaryTrimCodes?.length >= 4
                        ? originalIndex
                        : secondaryTrimCodes?.indexOf(vehicleCode);

                    if (newIndex !== -1) {
                        filteredLockedVehicles[key].push({
                            ...lockedVehicle,
                            vehicleIndex: newIndex
                        });
                    }
                });
            }
        }
    }
    return filteredLockedVehicles;
};

export const getYears = (state) => {
    let yearsMap = {};

    state.vehicle.vehicles && state.vehicle.vehicles.forEach((item, index) => {
        yearsMap[item.year] = "";
    });
    return Object.keys(yearsMap).sort((a, b) => b - a);
};

export const vehicleInfo = (state) => {
    const selectedVehicle = state.vehicle.activeToolTipVehicle;
    let featureVehicles = state.vehicle.featureVehicles;

    const removedVehicleCodes = state.vehicle.removedVehicleCodes;
    const vehicleToRemove = [];

    featureVehicles = featureVehicles.filter((vehicle, index) => {
        if (removedVehicleCodes.includes(vehicle.code) && !vehicleToRemove.includes(index)) {
            vehicleToRemove.push(index);
            return false;
        }
        return true;
    });
    const vehicleDetail = featureVehicles.find((vehicle, index) => index === selectedVehicle);
    return vehicleDetail;
};

export const setSecondaryYears = (state) => {
    const sortedSecondaryYear = [...state.vehicle.secondaryYear];
    sortedSecondaryYear.sort((a, b) => b - a);

    return sortedSecondaryYear;
};

export const getVehicleTypesName = (state) =>
    state.vehicle.driveTypeDefault.VEHICLE_TYPE_NAME;

export const getVehicleTypes = (state) =>
    state.vehicle.driveTypeDefault.VEHICLE_TYPE;

export const getDriveTypess = (state) => {
    let default_type = [];

    if (state.vehicle.featureDefinitions) {
        default_type = state.vehicle.featureDefinitions.WHEEL_BASE;
    }

    return default_type;
};

export const getSortedCompareTrims = (state) => {
    const vehiclesTrim = state.vehicle.trimVehicle;
    const sortedVehicle = [];

    vehiclesTrim.map((vehicle) => (
        sortedVehicle.push(vehicle.code)
    ))
    return sortedVehicle;
}

export const setCompareImages = (state) => {
    let featureVehicles = state.vehicle.compareImages;
    const removedVehicleCodes = state.vehicle.removedVehicleCodes;
    const vehicleToRemove = [];

    featureVehicles = featureVehicles && featureVehicles.filter((vehicle, index) => {
        if (vehicleToRemove.length === removedVehicleCodes.length) {
            return true;
        }

        if (index !==0 && removedVehicleCodes.includes(vehicle.code)  && !vehicleToRemove.includes(index)) {
            vehicleToRemove.push(index);
            return false;
        }
        return true;
    });

    if (state.vehicle.imageAngle && featureVehicles) {
        featureVehicles = featureVehicles.map((vehicle, index) => {
            if (vehicle === null) {
                // If the vehicle was removed, return null for that index
                return null;
            }

            const updatedVehicle = {...vehicle};

            if (updatedVehicle.media === undefined) {
                // If a vehicle has no media object, add a default object for carousel
                updatedVehicle.media = {};
            }

            const allMedia = Object.values(updatedVehicle.media).length ? Object.values(updatedVehicle.media[Object.keys(updatedVehicle.media)[0]]) : [];
            const filteredMedia = allMedia.filter((Type) => Type.imageType === state.vehicle.imageAngle);
            const remainingMedia = allMedia.filter((Type) => Type.imageType !== state.vehicle.imageAngle);

            if (!remainingMedia.length > 0 ) {
                const defaultInteriorImage = { code: "default_interior", imageType: "INTERIOR", url: "" };
                remainingMedia.push(defaultInteriorImage);
            }else if (!filteredMedia.length > 0 && state.vehicle.imageAngle === "INTERIOR" ){
                const defaultInteriorImage = { code: "default_interior", imageType: "INTERIOR", url: "" };
                filteredMedia.push(defaultInteriorImage);
            }

            const newMedia = {
                ...filteredMedia.reduce((acc, media) => {
                    return {
                        ...acc,
                        [media.code]: media,
                    };
                }, {}),
                ...remainingMedia.reduce((acc, media) => {
                    return {
                        ...acc,
                        [media.code]: media,
                    };
                }, {}),
            };

            if (index !== 0 && vehicle?.media !== undefined && Object.keys(vehicle?.media).length <1) {
                const primaryMedia = featureVehicles[0].media;
                const primaryMediaKeys = Object.keys(primaryMedia);
                const primaryMediaCodes = primaryMediaKeys.length ? Object.keys(primaryMedia[primaryMediaKeys[0]]) : [];
                const missingMediaCodes = primaryMediaCodes.filter(code => !Object.keys(newMedia).includes(code));

                missingMediaCodes.forEach(code => {
                    newMedia[code] = { code: code, imageType: state.vehicle.imageAngle, url: "" };
                });
            }

            return {
                ...updatedVehicle,
                media: {
                    ...updatedVehicle.media,
                    [Object.keys(updatedVehicle.media)[0]]: Object.values(newMedia),
                },
            };
        });
    }
    return featureVehicles;
};

export const getPrimaryandSecondaryVehicles = (state) => {
    let featureVehicles = state.vehicle.featureVehicles;
    const removedVehicleCodes = state.vehicle.removedVehicleCodes;
    const vehicleToRemove = [];

    featureVehicles = featureVehicles.filter((vehicle, index) => {
        if (vehicleToRemove.length === removedVehicleCodes.length) {
            return true;
        }

        if (index !==0 && removedVehicleCodes.includes(vehicle.code)  && !vehicleToRemove.includes(index)) {
            vehicleToRemove.push(index);
            return false;
        }
        return true;
    });

    return featureVehicles;
};

export const getSecondarYvehicle = (state) => {
    let featureVehicles = state.vehicle.featureVehicles;


    const activeVehicleIndex = state.vehicle.activeVehicleIndex;

    if (activeVehicleIndex >= 0 && activeVehicleIndex < featureVehicles.length - 1) {
        // Check if the activeVehicleIndex is within the valid range
        const secondaryVehicle = featureVehicles[activeVehicleIndex + 1];
        return secondaryVehicle;
    }
    // Return null if the activeVehicleIndex is out of range or featureVehicles is empty
    return null;
};

export const secondaryVehiclesTrims = (state) => {
    const featureVehicles = getPrimaryandSecondaryVehicles(state);
    const photosVehicles = setCompareImages(state)
    const currentTraget = setCurrentTarget(state)
    let secondaryTrimCodes = [];

    if (featureVehicles && currentTraget && currentTraget === "Features"){
        secondaryTrimCodes = featureVehicles.map((vehicle) => vehicle?.code);
        sessionStorage.setItem("secondaryTrimCodes", JSON.stringify(secondaryTrimCodes));
        return secondaryTrimCodes;
    }

    if (photosVehicles && currentTraget && currentTraget === "Photos"){
        secondaryTrimCodes = photosVehicles.map((vehicle) => vehicle?.code);
        sessionStorage.setItem("secondaryTrimCodes", JSON.stringify(secondaryTrimCodes));
        return secondaryTrimCodes;
    }
};

const filterVehiclesByPriceRange = (item, priceRange) => {
    let minMsrp = item.pricing[Object.keys(item.pricing)[0]];
    let maxMsrp = item.pricing[Object.keys(item.pricing)[1]];
    let filterMinPrice = priceRange[0];
    let filterMaxPrice = priceRange[1];
    if (minMsrp >= filterMinPrice) {
        if (maxMsrp <= filterMaxPrice) {
            return true;
        } else if (maxMsrp >= filterMaxPrice && filterMaxPrice >= minMsrp) {
            return true;
        }
    } else if (maxMsrp >= filterMinPrice) {
        if (maxMsrp <= filterMaxPrice) {
            return true;
        }
    }
    return false;
};

export const labelPriceRange = (state) => state.vehicle.filteredPrice;


export const filterVehiclesOnSubmit = (state) => {
    let retObj = {};
    if (!!state.vehicle.filters && !!state.vehicle.filters.segments) {
        const { year, filters } = state.vehicle;
        filters.segments.forEach((segment) => {
            retObj[segment] = state.vehicle.vehicles.filter((item, _index) => {
                if (item.year === year) {
                    if (state.vehicle.priceRange.length > 0 && !(state.vehicle.filterSegment.length > 0)) {
                        return filterVehiclesByPriceRange(item, state.vehicle.priceRange) && item.segments.includes(segment);
                    }
                    else if (state.vehicle.priceRange.length > 0 && state.vehicle.priceRange.length ){
                       return filterVehiclesByPriceRange(item, state.vehicle.priceRange) && state.vehicle?.filterSegment.includes(segment) && item.segments.includes(segment);
                    }
                    else {
                        return item.segments.includes(segment);
                    }
                }
                return false;
            });
        });
    }
    return retObj;
};

export const filterVehiclesFromPriceRange = (state) => {
    let retObj = [];
    if (!!state.vehicle.filters && !!state.vehicle.filters.segments) {
        const { year, filters } = state.vehicle;
        filters.segments.forEach((segment) => {
            const vehicles = state.vehicle.vehicles.filter((item, _index) => {
                if (item.year === year) {
                    if (state.vehicle?.filteredPrice && state.vehicle?.filteredPrice.length > 0 ) {
                        return filterVehiclesByPriceRange(item, state.vehicle.filteredPrice) && item.segments.includes(segment);
                    }
                }
                return false;
            });
            if (vehicles.length > 0) {
                retObj.push(segment);
            }
        });
    }
    return retObj;
};

export const getFilterSegment = (state) => {
    let retObj = [];

    if (!!state.vehicle.filters && !!state.vehicle.filters.segments) {
        const { year, filters } = state.vehicle;
        filters.segments.forEach((segment) => {
            const vehicles = state.vehicle.vehicles.filter((item, _index) => {
                if (item.year === year) {

                    if (state.vehicle?.filterSegment && state.vehicle?.filteredPrice && state.vehicle?.filteredPrice.length > 0) {
                        return filterVehiclesByPriceRange(item, state.vehicle.filteredPrice) && state.vehicle?.filterSegment.includes(segment) && item.segments.includes(segment);
                    } else if (state.vehicle?.filterSegment && state.vehicle?.filterSegment.length > 0 ) {
                        return state.vehicle?.filterSegment.includes(segment) && item.segments.includes(segment);
                    }
                }
                return false;
            });

            if (vehicles.length > 0) {
                retObj.push(segment);
            }
        });
    }
    return retObj;
}

export const getFilterSegmentClicked = (state) => {
    let retObj = [];

    if (!!state.vehicle.filters && !!state.vehicle.filters.segments) {
        const { year, filters } = state.vehicle;
        filters.segments.forEach((segment) => {
            const vehicles = state.vehicle.vehicles.filter((item, _index) => {
                if (item.year === year) {

                    if (state.vehicle?.selectedSegmentArray && state.vehicle?.filteredPrice && state.vehicle?.filteredPrice.length > 0) {
                        return filterVehiclesByPriceRange(item, state.vehicle.filteredPrice) && state.vehicle?.selectedSegmentArray.includes(segment) && item.segments.includes(segment);
                    } else if (state.vehicle?.selectedSegmentArray && state.vehicle?.selectedSegmentArray.length > 0 ) {
                        return state.vehicle?.selectedSegmentArray.includes(segment) && item.segments.includes(segment);
                    }
                }
                return false;
            });

            if (vehicles.length > 0) {
                retObj.push(segment);
            }
        });
    }
    return retObj;
}

export const filteredVehicleTypeOnSubmit = (state) => {
    let retObj = [];

    if (!!state.vehicle.filters && !!state.vehicle.filters.segments) {
        const { year, filters } = state.vehicle;
        filters.segments.forEach((segment) => {
            const vehicles = state.vehicle.vehicles.filter((item, _index) => {
                if (item.year === year) {

                    if (state.vehicle?.filterSegment && state.vehicle?.filteredPrice && state.vehicle?.filteredPrice.length > 0) {
                        return filterVehiclesByPriceRange(item, state.vehicle.filteredPrice) && state.vehicle?.filterSegment.includes(segment) && item.segments.includes(segment);
                    } else if (state.vehicle?.filterSegment && state.vehicle?.filterSegment.length > 0 ) {
                        return state.vehicle?.filterSegment.includes(segment) && item.segments.includes(segment);
                    }
                }
                return false;
            });

            if (vehicles.length > 0) {
                retObj.push(segment);
            }
        });
    }
    return retObj;
}

export const getDefaultVehicleSegments = (state) => {
    const { year, vehicles } = state.vehicle;
    const segmentCategories = new Set();

    vehicles && vehicles.forEach((vehicle) => {
        if (vehicle.year === year) {
            vehicle.segments.forEach((segment) => {
                segmentCategories.add(segment);
            });
        }
    });

    return Array.from(segmentCategories);
};

export const getCategoriesName = (state) => {
    let categories = [];
    Object.values(state.vehicle.features).forEach((feature) => {
        categories.push(feature.name);
    });

    state.vehicle.expandedCategory?.forEach((obj) => {
        if (!obj.newExpanded && obj.panel !== "all") {
            categories = categories.filter(category => ![obj.panel?.toString(), "all"].includes(category));
        } else if (!categories.includes(obj.panel.toString()) && obj.panel !== "all") {
            categories.push(obj.panel.toString());
        } else {
            if (obj.panel === "all" && !obj.newExpanded) {
                categories = categories.filter((category) => category === "all");
            } else if (obj.panel === "all" && obj.newExpanded) {
                return categories.filter((category) => category === "all");
            }
        }
    });
    return categories;
};

export const getFeatureLabel = (state) => {
    const filteredFeatures = {};
    let categories = {};
    const featureCate = {}

    let featureVehicles = state.vehicle.featureVehicles;
    const removedVehicleCodes = state.vehicle.removedVehicleCodes;
    const vehicleToRemove = [];

    featureVehicles.filter((vehicle, index) => {
        if (vehicleToRemove.length === removedVehicleCodes.length) {
            return true;
        }

        if (index !==0 && removedVehicleCodes.includes(vehicle.code) && !vehicleToRemove.includes(index)) {
            vehicleToRemove.push(index);
            return false;
        }
        return true;
    });

    const filterComparisons = (comparisons) =>
        comparisons.filter((comparisons, index) => !vehicleToRemove.includes(index));

    function processFeatureRows(filteredFeatureRows, values) {
        return {
            category: values.category,
            disclaimer: values?.disclaimer ? values.disclaimer : null,
            featureRows: filteredFeatureRows.map((featureRow) => ({
                ...featureRow,
                comparisons: filterComparisons(featureRow.comparisons),
            })),
            name: values.name,
        };
    }

    Object.values(state.vehicle.features).forEach((feature) => {
        categories[feature.category] = { ...feature };
    });

    let featureCategory = Object.values(categories).map((values) => ({
        ...values,
        featureRows: values.featureRows.slice(),
    }));

    if (state.vehicle.isDifferenceOnly) {
        featureCategory = featureCategory.map((category) => ({
            ...category,
            featureRows: category.featureRows.filter(row => row.hasDiff),
        }));
    }

    if (state.vehicle.isCheckedAdvantages) {
        featureCategory = featureCategory.map((category) => ({
            ...category,
            featureRows: category.featureRows.filter((row) =>
                    (state.vehicle.allAdvantage==="false" && row.comparisons.some((comparison, index) =>
                        index > 0 && row.comparisons[0].weight > comparison.weight
                    )) || (state.vehicle.allAdvantage==="true" &&
                        row.comparisons.every((comparison, index) =>
                            index === 0 || (row.comparisons[0].weight > comparison.weight)
                        )
                    )
            ),
        }));
    }

    if (state.vehicle.isFeatureChecked) {
        featureCategory = featureCategory.map((category) => ({
            ...category,
            featureRows: category.featureRows.filter((row) => {
                if (row.id === "pricing3") return true;
                const value = row.comparisons[0]?.value;
                return !["No", "None", "Null", "Non", "Ninguno", "Aucun", null].includes(value);
            }),
        }));
    }

    featureCategory.forEach((category) => {
        if (category.featureRows.length > 0) {
            filteredFeatures[category.name] = processFeatureRows(category.featureRows, category);
        }
    });

    function getSearchedFeature(featureCategories) {
        const search = state.vehicle.featureSearch?.trim().toLowerCase();
        if (search && search.length >= 2) {
            Object.values(featureCategories).forEach((feature) => {
                if (feature.name.toLowerCase().includes(search)) {
                    featureCate[feature.category] = { ...feature };
                } else {
                    const filteredRows = feature.featureRows.filter((row) =>
                        row.label.toLowerCase().includes(search)
                    );
                    if (filteredRows.length) {
                        featureCate[feature.category] = {
                            ...feature,
                            featureRows: filteredRows,
                        };
                    }
                }
            });
            return featureCate;
        }
        return featureCategories;
    }

    return state.vehicle.featureSearch
        ? getSearchedFeature(filteredFeatures)
        : filteredFeatures;
};

export const setCompareDataGroupInfo = (state) => {
    const primaryVehicleDescription = state.vehicle.primaryVehicleDescription;
    const secondaryOneVehicleDescription = state.vehicle.secondaryOneVehicleDescription;
    const secondaryTwoVehicleDescription = state.vehicle.secondaryTwoVehicleDescription;
    const secondaryThreeVehicleDescription = state.vehicle.secondaryThreeVehicleDescription;
    const color =state.vehicle.color && state.vehicle.color[0];
    const primaryVehicleMSRP = state.vehicle.primaryVehicleMSRP;
    const secondaryOneVehicleMSRP = state.vehicle.secondaryOneVehicleMSRP;
    const secondaryTwoVehicleMSRP = state.vehicle.secondaryTwoVehicleMSRP;
    const secondaryThreeVehicleMSRP = state.vehicle.secondaryThreeVehicleMSRP;
    const tenant = buildProfileName(state.vehicle.client, state.vehicle.country)
    const language =state.vehicle.activeLocale;
    const primaryVehicleYear = state.vehicle.primaryVehicleYear;
    const primaryVehicleTrim = state.vehicle.primaryVehicleTrim;
    const primaryVehicleMake = state.vehicle.primaryVehicleMake;
    const primaryVehicleModel = state.vehicle.primaryVehicleModel;
    const errorCode = state.vehicle.errorCode

    return {
        primaryVehicleDescription, secondaryOneVehicleDescription, secondaryTwoVehicleDescription , secondaryThreeVehicleDescription
        , color, primaryVehicleMSRP, secondaryOneVehicleMSRP, secondaryTwoVehicleMSRP, secondaryThreeVehicleMSRP,
        tenant, language, primaryVehicleYear, primaryVehicleTrim, primaryVehicleMake,primaryVehicleModel,errorCode
    }
}

export const setBaseGroup = (state) => {
    const tenant = buildProfileName(state.vehicle.client, state.vehicle.country)
    const language = state.vehicle.activeLocale;
    return { tenant, language };
}

export const setFilterGroup = (state) => {
    const tenant = buildProfileName(state.vehicle.client, state.vehicle.country);
    const language = state.vehicle.activeLocale;
    const minimumPrice =  state.vehicle.minimumPrice;
    const maximumPrice =  state.vehicle.maximumPrice;

    return {tenant, language, minimumPrice, maximumPrice};
}

function getUniqueSortedSet(data, key) {
    const set = new Set();
    data.forEach(vehicle => {
        set.add(vehicle.features[key]);
    });
    return [...set].sort((a, b) => a.localeCompare(b));
}

const hasSecondariesChanged = (TrimCode,state) => {
    const secondaryTrimsString = sessionStorage.getItem("secondaryTrimCodes");
    const secondaryVehicleCodes = JSON.parse(secondaryTrimsString.trim());

    if (TrimCode?.code[0].code !== secondaryVehicleCodes[0] && secondaryVehicleCodes && TrimCode?.code[0].code){
        return false;
    }

    if (TrimCode?.code.length !== secondaryVehicleCodes.length){
        return true;
    }

    if (TrimCode?.code.length === secondaryVehicleCodes.length){
        if(!!(state.vehicle?.lockedVehicles)){
            return !!(state.vehicle?.lockedVehicles);
        }
        return arraysSame(TrimCode?.code, secondaryVehicleCodes);
    }
    return false
};

function arraysSame (previousSecondariesCode, secondaries) {
    let isSame = true;
    for (let i = 0; i < previousSecondariesCode.length; i++) {
        if (previousSecondariesCode[i]?.code !== secondaries[i]) {
            isSame = false;
            break;
        }
    }
    return isSame;
}